import React, { useEffect, useState } from "react";

import { languageService } from "./lang/Lang.js";


import { connect } from "react-redux";
import { compose } from "redux";

import { Link } from "react-router-dom";

import { getUser } from "../store/actions/homeActions";
import PIGU from "../assets/images/favicon.svg";
import ChatAnimation from "../components/ChatAnimation";


import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
import ReactHtmlParser from 'react-html-parser';

import { LinkWithQuery } from './LinkWithQuery';



import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';

import 'react-accessible-accordion/dist/fancy-example.css';







function Home(props) {

  const { profile, loggedin, getUserFN, query } = props;
  const [langselected, setlangselected] = useState("en");

  //const t = useTranslation();




  useEffect(() => {
    // Update the document title using the browser API

    getUserFN(profile.id);
    setlangselected(languageService.getLanguage());




    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);



  useEffect(() => {
    // Update the document title using the browser API
    getUserFN(profile.id);

    //console.log(convs);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loggedin]);







  return (
    <div className="container" style={{ background: "#fff" }}>
      <div className="columns" style={{
        backgroundImage: ``,
        backgroundSize: "cover",
        height: "55vh",
        padding: 0,
        margin: 0,
        display: "table",
        marginTop: "60px"

      }}>


        <div className="column is-7 has-text-left mobonly" style={{ paddingLeft: "20px", backgroundColor: "", display: "table-cell", verticalAlign: "middle" }}>

          <h1 style={{ fontSize: "2.2em", color: "#F35875" }}><span style={{ color: "#F35875" }}>{languageService.translate('home.h1')}</span></h1>
          <h1 style={{ fontSize: "2em" }}><span style={{ color: "#3C2200" }}>{languageService.translate('home.p1')}</span></h1>
          <div style={{ height: "30px" }}></div>
          <LinkWithQuery
            style={{
              padding: "10px 15px",
              fontSize: "1.1rem",
              fontWeight: "600",
              border: 0,
              color: "#fff",
              background: "#F35875",
              borderRadius: "3px",
            }}
            className="ovvvee"
            to="/phone-login"
            query={query}
          >
            {languageService.translate('home.b1')}
          </LinkWithQuery>

          <button
            className="ovvvee"
            style={{
              padding: "10px 15px",
              fontSize: "1.1rem",
              fontWeight: "600",
              border: "1px solid #3C2200",
              color: "#3C2200",
              background: "#fff",
              borderRadius: "3px",
              marginLeft: "20px"
            }}
            onClick={() => {

              // window.scrollTo(0, 100);
              window.scrollTo({ top: 450, behavior: 'smooth' });


            }}
          >
            {languageService.translate('home.b2')}
          </button>






        </div>


        <div className="column is-5 has-text-left mobonly" style={{ display: "table-cell", verticalAlign: "middle", textAlign: "center" }}>

          <ChatAnimation language={langselected} />

        </div>





      </div>



      <div className="columns is-vcentered is-multiline" style={{
        padding: 0,
        margin: 0,
      }}>


        <div className="column is-7" style={{}}>
          <h1 style={{ fontSize: "2em", color: "#F35875" }}><span style={{ color: "#F35875" }}>{languageService.translate('home.h2')}
          </span></h1>
          <div style={{ height: "5px" }}></div>
          <p style={{ fontSize: "1.2em", color: "#3C2200" }}>
            {ReactHtmlParser(languageService.translate('home.p2'))}

          </p>
          <br />
          <p style={{ fontSize: "1.2em", color: "#3C2200" }}>

            {ReactHtmlParser(languageService.translate('home.p3'))}
          </p>

          <br />


          <p style={{ fontSize: "1.2em", color: "#3C2200" }}>
            {ReactHtmlParser(languageService.translate('home.p4'))}
          </p>

          <div style={{ height: "35px" }}></div>

          <LinkWithQuery
            className="ovvvee"
            style={{
              padding: "10px 15px",
              fontSize: "1.1rem",
              fontWeight: "600",
              border: "1px solid #3C2200",
              color: "#3C2200",
              background: "#fff",
              borderRadius: "3px",
            }}
            to="/phone-login"
          >
            {ReactHtmlParser(languageService.translate('home.b1'))}
          </LinkWithQuery>



        </div>


        <div className="column is-5" style={{ textAlign: "center" }}>
          <div style={{ height: "40px" }}></div>
          <img src={PIGU} style={{ height: "250px" }} alt="pigu" />
        </div>




      </div>




      <div style={{ height: "20px" }}></div>


      <div className="columns is-multiline" style={{
        padding: 0,
        margin: 0,
      }}>

        <div className="column is-12" style={{}}>
          <h1 style={{ fontSize: "2em", color: "#F35875" }}><span style={{ color: "#F35875" }}>{ReactHtmlParser(languageService.translate('home.h3'))}
          </span></h1>
          <div style={{ height: "20px" }}></div>

          <Carousel interval={6000} showStatus={false} autoPlay={true} infiniteLoop={true}>
            <div key="slide1" style={{ padding: 40, background: "#FFE983", borderRadius: "5px" }}>
              <i>{ReactHtmlParser(languageService.translate('home.t1'))}</i>
              <div style={{ height: "10px" }}></div>
              <p><b>Emma L.</b></p>
            </div>
            <div key="slide2" style={{ padding: 40, background: "#FFE983", borderRadius: "5px" }}>
              <i>{ReactHtmlParser(languageService.translate('home.t2'))}</i>
              <div style={{ height: "10px" }}></div>
              <p><b>James K.</b></p>
            </div>

            <div key="slide3" style={{ padding: 40, background: "#FFE983", borderRadius: "5px" }}>
              <i>{ReactHtmlParser(languageService.translate('home.t3'))}</i>
              <div style={{ height: "10px" }}></div>
              <p><b>Maria C.</b></p>
            </div>


          </Carousel>

        </div>
      </div>


      <div style={{ height: "20px" }}></div>


      <div className="separator"> <LinkWithQuery
        style={{
          padding: "10px 15px",
          fontSize: "1.1rem",
          fontWeight: "600",
          border: 0,
          color: "#fff",
          background: "#F35875",
          borderRadius: "3px",
        }}
        className="ovvvee"
        to="/phone-login"
      >{ReactHtmlParser(languageService.translate('home.b1'))}</LinkWithQuery></div>




      <div style={{ height: "40px" }}></div>

      <div id="faq-section" className="columns is-multiline" style={{
        padding: 0,
        margin: 0
      }}>



        <div className="column is-12" style={{}}>
          <h1 style={{ fontSize: "2em", color: "#F35875" }}><span style={{ color: "#F35875" }}>F.A.Q.</span></h1>


          <div style={{ height: "10px" }}></div>
          <Accordion>
            <AccordionItem>
              <AccordionItemHeading>
                <AccordionItemButton>
                  {ReactHtmlParser(languageService.translate('home.f1'))}
                </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>
                <p>
                  {ReactHtmlParser(languageService.translate('home.f1_r'))}                </p>
              </AccordionItemPanel>
            </AccordionItem>
            <AccordionItem>
              <AccordionItemHeading>
                <AccordionItemButton>
                  {ReactHtmlParser(languageService.translate('home.f2'))}
                </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>
                {ReactHtmlParser(languageService.translate('home.f2_r'))}

              </AccordionItemPanel>
            </AccordionItem>


            <AccordionItem>
              <AccordionItemHeading>
                <AccordionItemButton>
                  {ReactHtmlParser(languageService.translate('home.f3'))}
                </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>
                {ReactHtmlParser(languageService.translate('home.f3_r'))}


              </AccordionItemPanel>
            </AccordionItem>






            <AccordionItem>
              <AccordionItemHeading>
                <AccordionItemButton>
                  {ReactHtmlParser(languageService.translate('home.f4'))}

                </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>

                {ReactHtmlParser(languageService.translate('home.f4_r'))}

              </AccordionItemPanel>
            </AccordionItem>




            <AccordionItem>
              <AccordionItemHeading>
                <AccordionItemButton>
                  {ReactHtmlParser(languageService.translate('home.f5'))}

                </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>

                {ReactHtmlParser(languageService.translate('home.f5_r'))}


              </AccordionItemPanel>
            </AccordionItem>




            <AccordionItem>
              <AccordionItemHeading>
                <AccordionItemButton>
                  {ReactHtmlParser(languageService.translate('home.f6'))}

                </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>
                {ReactHtmlParser(languageService.translate('home.f6_r'))}
              </AccordionItemPanel>
            </AccordionItem>


          </Accordion>


        </div>


      </div>
      <div style={{ height: "20px" }}></div>


      <div style={{ color: "#3C2200", padding: "10px" }}>
        &copy; {process.env.REACT_APP_COPYRIGHT_YEAR || "2023"} {process.env.REACT_APP_COMPANY_NAME || "Adjomo Global"} • <Link to="/terms">{ReactHtmlParser(languageService.translate('home.footer1'))}</Link> • <Link to="/privacy">{ReactHtmlParser(languageService.translate('home.footer2'))}</Link> • <a href={`mailto:${process.env.REACT_APP_SUPPORT_EMAIL || "hello@sahra.ai"}`}>{ReactHtmlParser(languageService.translate('home.footer3'))}</a>

        <div style={{ height: "30px" }}></div>

      </div>
    </div>);

}

const mapStateToProps = (state) => {
  return {
    loggedin: state.home.loggedin,
    convs: state.home.convs,
    profile: state.home.profile,
    userdata: state.home.userdata,

  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getUserFN: (id) =>
      dispatch(getUser(id))
  };
};


export default compose(connect(mapStateToProps, mapDispatchToProps))(Home);
